import { ECodeSessionStatus } from "@frontend-shared/types";

// NOTE: Shared by the status badge and the sidebar rows so a session's colour
// means the same thing in both places.
export const SESSION_DOT_CLASS_MAP: Record<ECodeSessionStatus, string> = {
  [ECodeSessionStatus.QUEUED]: "bg-primary",
  [ECodeSessionStatus.RUNNING]: "bg-primary",
  [ECodeSessionStatus.AWAITING_INPUT]: "bg-amber-500",
  [ECodeSessionStatus.SUCCEEDED]: "bg-green-500",
  [ECodeSessionStatus.FAILED]: "bg-destructive",
  [ECodeSessionStatus.CANCELLED]: "bg-foreground-secondary/60",
  [ECodeSessionStatus.TIMED_OUT]: "bg-destructive",
};
